import { IGpsrSkuItem } from 'redux/reducers/gpsr/types';
import { EIconButtons } from 'services/constants/iconsTypes';
import { ETableStructureAlign, ETableStructureType } from 'services/constants/tableStructureTypes';

export const gpsrSkuTableStructure = [
	{
		name: 'ID',
		selector: 'id' as keyof IGpsrSkuItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.LINK,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'SKU Name',
		selector: 'name' as keyof IGpsrSkuItem,
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Product Type ID',
		selector: 'productTypeId' as keyof IGpsrSkuItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Product Type',
		selector: 'productTypeName' as keyof IGpsrSkuItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Actions',
		selector: 'File Report' as keyof IGpsrSkuItem,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [{ name: 'Delete', icon: EIconButtons.DELETE }],
		colSpan: 1,
	},
];
